import { render, staticRenderFns } from "./admin-contract-2025-show.vue?vue&type=template&id=6d51082c&scoped=true"
import script from "./admin-contract-2025-show.vue?vue&type=script&lang=js"
export * from "./admin-contract-2025-show.vue?vue&type=script&lang=js"
import style0 from "./admin-contract-2025-show.vue?vue&type=style&index=0&id=6d51082c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d51082c",
  null
  
)

export default component.exports